import { render, staticRenderFns } from "./EditedMenuItem.vue?vue&type=template&id=5c080cf1&"
import script from "./EditedMenuItem.vue?vue&type=script&lang=js&"
export * from "./EditedMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports